import { Dialog, IconButton, Stack, Typography } from '@mui/material';
import Icon from '@/components-new/common/icon/Icon';
import { FileDialogProps } from './types';

const FileDialog = (props: FileDialogProps) => {
  const { open, setOpen, title, document, type, tourId } = props;

  // Check if document is already a full URL or just a filename
  const isFullUrl = document && (document.startsWith('http://') || document.startsWith('https://'));
  const documentUrl = isFullUrl
    ? document
    : `${process.env.NEXT_PUBLIC_CDN}/tours/${tourId}/menus/files/${document}`;

  return (
    <Dialog open={open} fullScreen>
      <Stack
        direction="row"
        spacing={2}
        px={3}
        py={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ backgroundColor: '#000000CC' }}
      >
        <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#FFFFFF' }}>
          {title}
        </Typography>
        <IconButton onClick={() => setOpen(!open)}>
          <Icon icon="fa fa-times" />
        </IconButton>
      </Stack>
      <iframe
        src={`https://docs.google.com/viewer?url=${encodeURIComponent(documentUrl)}&embedded=true&preview=true`}
        // src={gallery[0].filePath}
        title="PDF Viewer"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </Dialog>
  );
};

export default FileDialog;